import i18n from '@/i18n/index'

const suppliersManager = [
  {
    path: '/suppliersManager',
    component: () => import('@/views/suppliersManager/index.vue'),
    meta: { name: i18n.t('menu.suppliersManager'), allowBreadcrumbRedirect: false },
    children: [
      {
        path: '/suppliersManager/suppliers',
        component: () => import('@/views/suppliersManager/suppliers/index.vue'),
        meta: { name: i18n.t('menu.suppliers'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'suppliersManagerList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'suppliersManagerList',
            component: () => import('@/views/suppliersManager/suppliers/list/index.vue'),
            meta: { name: i18n.t('text.list') }
          },
          {
            // 添加
            path: 'add',
            name: 'suppliersAdd',
            component: () => import('@/views/suppliersManager/suppliers/add/index.vue'),
            meta: { name: i18n.t('text.add') }
          },
          {
            // 编辑
            path: 'edit/:id',
            name: 'suppliersEdit',
            component: () => import('@/views/suppliersManager/suppliers/edit/index.vue'),
            meta: { name: i18n.t('text.edit') }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'suppliersDetail',
            component: () => import('@/views/suppliersManager/suppliers/detail/index.vue'),
            meta: { name: i18n.t('text.detail') }
          }
        ]
      },
      {
        path: '/suppliersManager/purchase',
        component: () => import('@/views/suppliersManager/purchase/index.vue'),
        meta: { name: i18n.t('menu.purchaseManagement'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'purchaseManagerList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'purchaseManagerList',
            component: () => import('@/views/suppliersManager/purchase/list/index.vue'),
            meta: { name: i18n.t('text.list') }
          },
          {
            // 添加
            path: 'add',
            name: 'purchaseAdd',
            component: () => import('@/views/suppliersManager/purchase/add/index.vue'),
            meta: { name: i18n.t('text.add') }
          },
          {
            // 编辑
            path: 'edit/:id',
            name: 'purchaseEdit',
            component: () => import('@/views/suppliersManager/purchase/add/index.vue'),
            meta: { name: i18n.t('text.edit') }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'purchaseDetail',
            component: () => import('@/views/suppliersManager/purchase/detail/index.vue'),
            meta: { name: i18n.t('text.detail') }
          },
          {
            path: 'downloadCenter',
            name: 'suppliersManagerPurchaseDownloadCenter',
            component: () => import(/* webpackChunkName: 'downloadCenter' */ '@/views/downloadCenter/downloadCenter.vue'),
            meta: { name: i18n.t('menu.downloadCenter'), keepAlive: false }
          }
        ]
      },
      {
        path: '/suppliersManager/returnOrder',
        component: () => import('@/views/suppliersManager/returnOrder/index.vue'),
        meta: { name: i18n.t('menu.returnOrderManagement'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'returnOrderManagerList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'returnOrderManagerList',
            component: () => import('@/views/suppliersManager/returnOrder/list/index.vue'),
            meta: { name: i18n.t('text.list') }
          },
          {
            // 添加
            path: 'add',
            name: 'returnOrderAdd',
            component: () => import('@/views/suppliersManager/returnOrder/add/index.vue'),
            meta: { name: i18n.t('text.add') }
          },
          {
            // 编辑
            path: 'edit/:id',
            name: 'returnOrderEdit',
            component: () => import('@/views/suppliersManager/returnOrder/add/index.vue'),
            meta: { name: i18n.t('text.edit') }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'returnOrderDetail',
            component: () => import('@/views/suppliersManager/returnOrder/detail/index.vue'),
            meta: { name: i18n.t('text.detail') }
          }
        ]
      }
    ]
  }
]

export default suppliersManager
